const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`<div id="signup-form-b">
  <div class="o-container--prose">
    <div class="o-container__content">
      <h2 class="heading">Get Weekly Digests</h2>
      <label for="demo-input">Send weekly digests to...</label>
      <div class="demo-input-basic demo-input-basic--single-line demo-input-button">
      <input
        type="email"
        value=""
        class="c-input"
        id="demo-input"
        placeholder="Example: you@somewhere.tld"
      />
      <button class="c-button" type="button">Subscribe</button>
      </div>
    </div>
  </div>
</div>
`);
            }

            getTemplateName() {
                return `d836a78f6c09a35741b15b4b20e5cb699763c791ca4938d35b9fc8ea10648742`;
            }

            getSourceContext() {
                return new this.Source(``, `d836a78f6c09a35741b15b4b20e5cb699763c791ca4938d35b9fc8ea10648742`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, 'd836a78f6c09a35741b15b4b20e5cb699763c791ca4938d35b9fc8ea10648742');

let template = env.loadTemplate('d836a78f6c09a35741b15b4b20e5cb699763c791ca4938d35b9fc8ea10648742');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/prototypes/email-signup/example/example-b.twig", args: context }
     );
     return rendered;;
};